import { Component } from '@angular/core';

@Component({
    selector: 'app-not-permission',
    templateUrl: './not-permission.component.html',
    styleUrls: ['./not-permission.component.scss', '../../Styles/GlobalStyles.css', '../../Global/Errors/close-session/close-session.component.scss'],
    standalone: false
})
export class NotPermissionComponent {

  //-================== FUNCTTION FOR GREETTING ==================-\\

  public GetGreeting(): string {

    let TextGTings: string = '';

    const Date_User = new Date();
    const Hour = Date_User.getHours();

    if (Hour >= 0 && Hour <= 5) {
      TextGTings = 'Buenas noches';
    } else if (Hour >= 6 && Hour <= 11) {
      TextGTings = 'Buenos días';
    } else if (Hour >= 12 && Hour <= 17) {
      TextGTings = 'Buenas tardes';
    } else if (Hour >= 18) {
      TextGTings = 'Buenas noches';
    }

    return TextGTings;
  }

  //-================ FUNCTION FOR NAME USER ================-\\
  public NameUser(): string {
    const Name_User: string = localStorage.getItem('Name_User') || "";
    return (Name_User.split(' ', 2)).join(' ');
  }

}
